// extracted by mini-css-extract-plugin
export default {"background":"AdminResponsiblePerson_background__+cTIS","fullWidth":"AdminResponsiblePerson_fullWidth__M6LG-"};